"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleSlideHOF = void 0;
// Higher Order Function that takes StateUpdater function
// and returns a function that opens slider. Used by Cart & MenuNav
// 1. Change the state of given function to true
// 2. Add css to body so that users cannot scroll outside the slider
var handleSlideHOF = function (setOpen) {
    return function (scrollValue) {
        var body = document.querySelector('body');
        if (Number.isFinite(scrollValue)) {
            body === null || body === void 0 ? void 0 : body.classList.add('js-menu-open');
            body === null || body === void 0 ? void 0 : body.setAttribute('style', "top:-".concat(scrollValue, "px"));
            setOpen(function () { return true; });
        }
        else {
            // Restore the previous scroll value from body's style
            var scrollToValue = parseInt((body === null || body === void 0 ? void 0 : body.style.top) || '0', 10) * -1;
            // Remove attributes in body for stopping scroll
            body === null || body === void 0 ? void 0 : body.classList.remove('js-menu-open');
            body === null || body === void 0 ? void 0 : body.removeAttribute('style');
            // Scroll down to where it was before opening the cart after removing overlay: hidden
            window.scrollTo(0, scrollToValue);
            setOpen(function () { return false; });
        }
    };
};
exports.handleSlideHOF = handleSlideHOF;
